import React from 'react';
import { useTranslation } from 'react-i18next';
import { config } from '../../common/';

import classNames from 'classnames';
// import bmwWeekImg from './assets/images/bmw-week.jpg';
// import miniDateImg from './assets/images/mini-date.jpg';
import testDriveBMW from './assets/images/test-drive-bmw.png';
import testDriveMINI from './assets/images/test-drive-mini.png';

const FooterCards: React.FC<{}> = (props) => {
    const { t } = useTranslation();

    const buildAdditionalEvent = (title: string, url: string, urlText: string, image: any) => {
        return (
            <div className={classNames(['cell', 'medium-4', 'pacotesOferta'])}>
                <div className={'card'}>
                    <img src={image} />
                    <div className={classNames(['card-section', 'mensagem'])}>
                        <p>{title}</p>
                    </div>
                    <div className={'card-image'}>
                        <a href={url} target="_blank" className={classNames(['button', 'campanha'])} title={urlText}>{urlText}</a>
                    </div>
                </div>
            </div>
        );
    };

    const buildAdditionalEventsList = () => {
        const table: JSX.Element[] = [];

        const testDrive = buildAdditionalEvent(
            t('events:testDrive.title'),
            `${config.EventTestDriveURL}`,
            t('events:testDrive.urlText'),
            config.BrandEnv === 'BMW' ? testDriveBMW : testDriveMINI);

        // const bmwWeek = buildAdditionalEvent(
        //     t('events:bmwWeek.title'),
        //     `${config.EventBMWWeekURL}`,
        //     t('events:bmwWeek.urlText'),
        //     bmwWeekImg);

        // const miniDate = buildAdditionalEvent(
        //    t('events:miniDate.title'),
        //    `${config.EventMINIDateURL}`,
        //    t('events:miniDate.urlText'),
        //    miniDateImg);

        // if (config.BrandEnv === 'MINI' && config.ShowMINIDateEvent) {
        //    table.push(miniDate);
        // }

        table.push(testDrive);

        // if (config.BrandEnv === 'BMW' && config.ShowBMWWeekEvent) {
        //     table.push(bmwWeek);
        // }

        return (
            <div className={classNames(['grid-container', 'fluid', 'margin-top-2'])}>
                <div className={classNames(['grid-x', 'grid-margin-x'])}>
                    {table}
                </div>
            </div>
        );
    };

    return (
        <React.Fragment>
            {buildAdditionalEventsList()}
        </React.Fragment>
    );
};

export default FooterCards;
